import { defineComponent as _defineComponent } from 'vue';
import Sidebar from 'primevue/sidebar';
export default /*#__PURE__*/ _defineComponent({
    __name: 'StationDetails',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        weatherStation: {
            type: Object,
            required: true,
        },
    },
    emits: ['save', 'cancel', 'update:visible'],
    setup(__props, { expose, emit }) {
        expose();
        const __returned__ = { emit, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
